const data = [
    {
        id: 1,
        place: "Amritsar",
        exp: "It was wonderfull morning when I visited the Golden Temple, I then ate Langar there, and slept in the hall of temple in afternoon. I also did shoe polishing sewa there. Pretty pleasant experience.",
        img: "https://images.unsplash.com/photo-1609947017136-9daf32a5eb16?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Z29sZGVuJTIwdGVtcGxlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80"
    },
    {
        id: 2,
        place: "Heydrabad",
        exp: "My father was posted in Sinkederabad, and Heydrabad was nearby. One fine day we planned a visit to Heydrabad. We visited Char-minar, Ramoji Film City, Buddha Statue, Museum and many other places. I found Ramoji Film city to be the most iteresting.",
        img: "https://wallpaperaccess.com/full/4495586.jpg"
    }
];

export default data;